module.exports = __webpack_public_path__ + "static/media/services_specialoccasions.57e52613.jpg";